import generateUtilityClasses from '@mui/material/generateUtilityClasses';

export const dialogHeaderClasses = generateUtilityClasses('AFDialogHeader', [
  'helpIcon',
  'badge',
  'disclaimer',
  'description',
  'closeButton',
  'image',
  'actions'
]);
